const filter = () => {
    return (input) => {
        let specialChar = ['(Modified)'];
        let substring = "(Modified)";
        let word = input;
        if (word.length <= 30) {
            return word;
        }
        else {
            if (word.indexOf(substring) !== -1) {
                return word.substr(0, 27) + '... ' + substring;
            }
            else {
                return word.substr(0, 30) + '...';
            }
        }
    };
};
const ɵ0 = filter;
export const SingleDropdownSelectFilter = {
    name: 'singleDropdownSelect',
    filter: filter
};
export { ɵ0 };
//# sourceMappingURL=fourdotfive-single-dropdown-select.filter.js.map